import {
  onCLS,
  onFID,
  onFCP,
  onLCP,
  onTTFB,
  onINP,
  CLSThresholds,
  FIDThresholds,
  FCPThresholds,
  LCPThresholds,
  TTFBThresholds,
  INPThresholds
} from 'web-vitals';

function sendToGoogleAnalytics({ name, delta, id }) {
  let metricRating;
  let thresholds;
  switch (name) {
    case 'CLS':
      thresholds = CLSThresholds;
      break;
    case 'FID':
      thresholds = FIDThresholds;
      break;
    case 'FCP':
      thresholds = FCPThresholds;
      break;
    case 'LCP':
      thresholds = LCPThresholds;
      break;
    case 'TTFB':
      thresholds = TTFBThresholds;
      break;
    case 'INP':
      thresholds = INPThresholds;
      break;
    default:
      thresholds = null;
      break;
    // ***Thresholds are an array with 2 values that define the desired range of the metric.
  }

  if (thresholds) {
    if (delta < thresholds[0]) {
      metricRating = 'good';
    } else if (delta >= thresholds[0] && delta <= thresholds[1]) {
      metricRating = 'needs-improvement';
    } else {
      metricRating = 'poor';
    }
  } else {
    metricRating = 'unknown';
  }

  window?.gtag('event', name, {
    value: delta,
    metricId: id,
    metricRating
  });
}

onCLS(sendToGoogleAnalytics);
onFID(sendToGoogleAnalytics);
onFCP(sendToGoogleAnalytics);
onLCP(sendToGoogleAnalytics);
onTTFB(sendToGoogleAnalytics);
onINP(sendToGoogleAnalytics);
